import React, { useRef } from 'react'
import { Button, Col, message, Modal, Row, Upload } from 'antd'
import { useJoinIntention } from '../intentionModel'
import { FileWordOutlined, InboxOutlined, UploadOutlined } from '@ant-design/icons'
import type { UploadFile, UploadProps } from 'antd/es/upload/interface'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseRequestUrl, getBaseUploadData, getBaseWebsiteUrlUrl, getToken } from '@/utils/constants'
import { useState } from 'react'
import { useEffect } from 'react'
import { CooperationAgreement, FranchiseePageResult, intentionService } from '../intentionService'
import useGlobalModel from '@/model/globalModel'
import moment from 'moment'
import styles from './contract.module.scss'
import QRCode from 'qrcode.react'
import YhTootip from '@/components/YhTootip'

const { Dragger } = Upload

export const Contract = ({ contractVisible, setContractVisible, id }) => {
    const formRef = useRef<IYhFormRef>()
    const { setLoadingInfo, setOfficeLookInfo } = useGlobalModel()
    const [cooperationAgreementForm, setCooperationAgreementForm] = useState<CooperationAgreement | null>()
    const [info, setInfo] = useState<FranchiseePageResult>()

    useEffect(() => {
        if (contractVisible) {
            geiDetail()
        }
    }, [contractVisible])

    const geiDetail = async () => {
        let { retData } = await intentionService.one(id)
        const { cooperationAgreementList, phone, contact } = retData
        if (cooperationAgreementList && cooperationAgreementList?.length > 0) {
            setCooperationAgreementForm(cooperationAgreementList[cooperationAgreementList.length - 1])
            const { fileName, mode, endTime, contact, phone } = cooperationAgreementList[cooperationAgreementList.length - 1]
            formRef.current?.setFieldsValue({ fileName, mode, endTime: endTime ? moment(endTime) : null, contact, phone })
        } else {
            setCooperationAgreementForm(null)
            formRef.current?.setFieldsValue({ phone, contact, mode: '双方签署' })
        }
        setInfo(retData)
    }

    const [fileList, setFileList] = useState<UploadFile[]>([])

    const baseFormItem: IYhFormItemsBox = {
        title: '基础信息',
        style: { padding: '20px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '协议名称',
                fieldName: 'fileName',
                rules: [{ required: true, message: '请输入组合名称' }],
                span: 8,
            },
            {
                type: FormItemTypeEnum.Radio,
                fieldLabel: '签署模式',
                fieldName: 'mode',
                rules: [{ required: true, message: '请选择签约模式' }],
                radioDs: [{ label: '双方签署', value: '双方签署' }],
                span: 8,
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '截止时间',
                fieldName: 'endTime',
                // rules: [{ required: true, message: '请选择截止时间' }],
                span: 8,
                showTime: true,
                format: 'YYYY-MM-DD HH:mm:ss',
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '签约人姓名',
                fieldName: 'contact',
                disable: true,
                span: 8,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '签约人手机',
                fieldName: 'phone',
                disable: true,
                span: 8,
            },
        ],
    }

    const fromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        formValues: [],
        // onChange,
        boxs: [baseFormItem],
        disabled: !!cooperationAgreementForm,
    }

    const props: UploadProps = {
        name: 'file',
        // multiple: true,
        action: getBaseImgUploadUrl(),
        data: getBaseUploadData(),
        listType: 'picture',
        fileList,
        onChange(info) {
            const { status } = info.file
            if (status !== 'uploading') {
                console.log(info.file, info.fileList)
            }
            if (status === 'done') {
                setLoadingInfo({ loadingVisible: false, txt: '' })
                setFileList([{ ...info.file, uid: info.file.response.retData }])
                message.success(`${info.file.name} 上传成功`)
                formRef.current?.setFieldsValue({ fileName: info.file.name })
            } else if (status === 'error') {
                message.error(`${info.file.name} 上传失败`)
                setFileList([])
                setLoadingInfo({ loadingVisible: false, txt: '' })
            }
        },
        onRemove() {
            setFileList([])
        },
        beforeUpload(file) {
            let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
            // let filetypes: string[] = ['.docx', '.doc']
            let filetypes: string[] = ['.pdf']
            let isType = filetypes?.includes(fileEnd)
            if (!isType) {
                message.error('不支持该格式的上传,当前仅支持.pdf类型文件。')
                return false
            }
            const isLt20M = file.size / 1024 / 1024 < 20
            if (!isLt20M) {
                message.error('上传到文件不能超过20M')
                return false
            }
            setLoadingInfo({ loadingVisible: true, txt: '上传中' })
            return true
        },
    }

    const onClose = () => {
        setContractVisible(false)
        formRef.current?.resetFields()
    }

    const onSubmit = () => {
        formRef.current
            ?.validateFields()
            .then(async (val) => {
                if (fileList && fileList.length > 0) {
                    const { uid: md5, fileName } = fileList[0]
                    let data = {
                        franchiseeId: info?.id,
                        md5,
                        fileName,
                        ...val,
                        endTime: val.endTime ? moment(val.endTime).format('YYYY-MM-DD HH:mm:ss') : null,
                    }
                    let { retData } = await intentionService.cooperationagreementInsert(data)
                    message.success('签署协议发起成功')
                    geiDetail()
                } else {
                    message.error('请上传协议！')
                }
            })
            .catch((err) => { })
    }

    const showAgreent = () => {
        setOfficeLookInfo({ visible: true, url: getBaseImgLookUrl(cooperationAgreementForm?.md5 as string) })
    }

    return (
        <Modal
            visible={contractVisible}
            title="发起签署"
            centered={true}
            onCancel={onClose}
            width={1000}
            footer={
                cooperationAgreementForm
                    ? [
                        <Button key="cancel" onClick={onClose}>
                            取消
                        </Button>,
                    ]
                    : [
                        <Button key="ok" type="primary" onClick={onSubmit}>
                            确定
                        </Button>,
                        <Button key="cancel" onClick={onClose}>
                            取消
                        </Button>,
                    ]
            }
        >
            {!cooperationAgreementForm ? (
                <div>
                    <p className={styles['title']}>上传文件签署</p>
                    <Dragger {...props} style={{ width: '400px' }}>
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                        </p>
                        <p className="ant-upload-text">点击上传，或将文件拖拽到此处</p>
                    </Dragger>
                    <YhFormBox {...fromConfig} />
                </div>
            ) : (
                <div>
                    <YhFormBox {...fromConfig} />
                    <div style={{ padding: '0 20px' }}>
                        <p className={styles['title']}>协议文件</p>
                        <div className={styles['agreementbox']} onClick={showAgreent}>
                            <FileWordOutlined style={{ fontSize: '30px' }} /> {cooperationAgreementForm.fileName}
                        </div>
                        <Row style={{ marginBottom: "20px" }}>
                            <Col span={4}>签约链接</Col>
                            <Col span={20}><YhTootip text={`${getBaseWebsiteUrlUrl()}/protocolView.html?franchiseeCode=${info?.code}`} style={{ width: "100%" }} /></Col>
                        </Row>
                        <Row >
                            <Col span={4}>签约二维码</Col>
                            <Col span={20}>
                                <QRCode
                                    value={`${getBaseWebsiteUrlUrl()}/protocolView.html?franchiseeCode=${info?.code}`} // 生成二维码的内容
                                    size={100} // 二维码的大小
                                    fgColor="#000000" // 二维码的颜色
                                // imageSettings={{ // 中间有图片logo
                                //   src: logo,
                                //   height: 60,
                                //   width: 60,
                                //   excavate: true
                                // }}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </Modal>
    )
}
